/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import type {AppThunkDispatch} from 'helpers/store'
import {OffersAction} from 'store/offers/OffersAction'
import {buildOfferPdfFilename, extractOfferConfirmationPdfResponse, extractOfferPdfResponse, resolveOfferPdfDownload,} from 'utils/offers/offersUtils'

interface ExportOfferPdfParams {
    dispatch: AppThunkDispatch
    exportId: number
    isCalculation: boolean
    isNetto: boolean
    offerNumber?: number | null
    calculationName?: string | null
    fallbackCalculationIndex?: number
}

interface ExportOfferConfirmationPdfParams {
    dispatch: AppThunkDispatch
	exportCalculationId: number
    offerNumber?: number | null
    calculationName?: string | null
    fallbackCalculationIndex?: number
}

export const exportOfferPdf = async ({
    dispatch,
    exportId,
    isCalculation,
    isNetto,
    offerNumber,
    calculationName,
    fallbackCalculationIndex = 1,
}: ExportOfferPdfParams): Promise<boolean> => {
    const result = await dispatch(OffersAction.fetchExportOfferPdf(exportId, isCalculation, isNetto))
    const { offer: offerFile, downloadAs } = extractOfferPdfResponse(result)

    return resolveOfferPdfDownload(
        offerFile,
        downloadAs || buildOfferPdfFilename(offerNumber, calculationName, fallbackCalculationIndex)
    )
}

export const exportOfferConfirmationPdf = async ({
    dispatch,
    exportCalculationId,
    offerNumber,
    calculationName,
    fallbackCalculationIndex = 1,
}: ExportOfferConfirmationPdfParams): Promise<boolean> => {
    const result = await dispatch(OffersAction.fetchExportOfferConfirmationPdf(exportCalculationId))
    const { pdf: offerFile, downloadAs } = extractOfferConfirmationPdfResponse(result)

    return resolveOfferPdfDownload(
        offerFile,
        downloadAs || buildOfferPdfFilename(offerNumber, calculationName, fallbackCalculationIndex)
    )
}
